<template>
  <div class="detail-section">
    <h4>
      <FontAwesomeIcon :icon="['far', icon ]"/>
      {{ title }}
    </h4>
    <div :class="{'is-indented': isIndented}"><slot/></div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from 'vue';
Vue.component('font-awesome-icon', FontAwesomeIcon)



export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    title: {
      type: String,
      required: true
    },
    isIndented: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    iconClass () {
      if (!this.icon) return null
      return this.icon
    }
  }
}
</script>

<style lang="sass">
.detail-section
  margin-bottom: 2rem

.is-indented
  margin-left: 2rem

  .detail
    margin-left: 0
</style>



// WEBPACK FOOTER //
// src/components/DetailSection.vue